export const handleFacebookShare = (url: string) => {
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url,
  )}`
  window.open(facebookShareUrl, '_blank', 'noopener,noreferrer')
}
